import { ALL_FILTER_OPTION } from 'components/lib/constants';

export const getFileGroups = (files: any[]): any[] => {
  const groupMap = new Map();
  (files ?? []).forEach((file: any) => {
    (file?.file_categories ?? []).forEach((category: any) => {
      const group = category?.file_group;
      if (group?.slug && !groupMap.has(group.slug)) {
        groupMap.set(group.slug, group);
      }
    });
  });
  return Array.from(groupMap.values()).sort((a: any, b: any) => a.sort_order - b.sort_order);
};

export const buildDocumentTabs = (groups: any[]) => [
  { key: ALL_FILTER_OPTION.value, label: ALL_FILTER_OPTION.label },
  ...groups.map((group: any) => ({ key: group.slug, label: group.name })),
];

export const fileMatchesGroup = (file: any, slug: string): boolean =>
  (file?.file_categories ?? []).some((category: any) => category?.file_group?.slug === slug);

export const filterFilesByTab = (files: any[], selectedTab: string): any[] =>
  selectedTab === ALL_FILTER_OPTION.value
    ? files
    : (files ?? []).filter((file: any) => fileMatchesGroup(file, selectedTab));

const fileSortTime = (file: any): number => new Date(file?.snapshot_date ?? file?.created_at ?? 0).getTime();

export const sortFilesByNewest = (files: any[]): any[] =>
  [...(files ?? [])].sort((a: any, b: any) => fileSortTime(b) - fileSortTime(a));
